import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  UpdateEstimateLineItemMaterialsInput,
  UpdateEstimateLineItemMaterialsMutation as UpdateEstimateLineItemMaterialsMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const UpdateEstimateLineItemMaterialsMutation = graphql(`
  mutation UpdateEstimateLineItemMaterials(
    $input: UpdateEstimateLineItemMaterialsInput!
  ) {
    updateEstimateLineItemMaterials(input: $input) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
        pendingSolarLayoutImage
      }
    }
  }
`);

const useUpdateEstimateLineItemMaterials = (args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    UpdateEstimateLineItemMaterialsMutationResult,
    Error,
    UpdateEstimateLineItemMaterialsInput
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<
    UpdateEstimateLineItemMaterialsMutationResult,
    Error,
    UpdateEstimateLineItemMaterialsInput
  >({
    mutationFn: (input) => {
      return gqlClient.request(UpdateEstimateLineItemMaterialsMutation, {
        input,
      });
    },
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.updateEstimateLineItemMaterials,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useUpdateEstimateLineItemMaterials;
